import { render } from "./TheProgressBar.vue?vue&type=template&id=3a3db2b4"
import script from "./TheProgressBar.vue?vue&type=script&lang=js"
export * from "./TheProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])